<template>
  <div class="view pa24">
    <el-dialog title="详细信息" :visible.sync="dialogTableVisible" append-to-body :close-on-click-modal="false">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="库存详情" name="stock">
          <distributionDetail  ref="stockModel"></distributionDetail>
        </el-tab-pane>
        <el-tab-pane label="入库详情" name="in">
          <distributionDetail  ref="inModel"></distributionDetail>
        </el-tab-pane>
        <el-tab-pane label="出库详情" name="out">
          <distributionDetail  ref="outModel"></distributionDetail>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>
<script>
import distributionDetail from "@/pages/warehouseLog/components/distributionDetail.vue";

export default {
  name: "distriHome",
  components: {
    distributionDetail
  },
  data() {
    return {
      activeName: 'stock',
      dialogTableVisible: false,
      dealerId: ''
    };
  },
  created() {
    // 获取所有代理商、经销商列表
  },
  methods: {
    handleClick(tab, event) {
      if ('stock' == tab.name) {
        this.$refs.stockModel.init(this.dealerId,-1)
      } else if ('in'==tab.name) {
        this.$refs.inModel.init(this.dealerId,1)
      }else if ('out'==tab.name){
        this.$refs.outModel.init(this.dealerId,2)
      }
    },
    open(dealerId) {
      this.dealerId = dealerId
      this.activeName = 'stock'
      this.dialogTableVisible = true
      this.$nextTick(()=>{
        this.$refs.stockModel.init(this.dealerId,-1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}
</style>

